<template>
  <div class="auth-page">
    <div class="auth-card">
      <router-link to="/" class="auth-back-link">
        <v-icon class="auth-back-icon" size="18">mdi-arrow-left</v-icon>
        <span>Back to home</span>
      </router-link>
      <router-link to="/" class="logo-link" aria-label="Lulu Rewards home">
        <img :src="logo" alt="Lulu Rewards" class="auth-logo" />
      </router-link>
      <h1 v-if="title" class="auth-title">{{ title }}</h1>
      <p v-if="subtitle" class="auth-subtitle">{{ subtitle }}</p>
      <slot />
      <div v-if="$slots.footer" class="auth-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logo: require("@/assets/logo.png"),
    };
  },
};
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--lulu-bg-gradient);
  padding: 24px;
}

.auth-card {
  background: var(--lulu-surface);
  border-radius: var(--lulu-radius-card);
  box-shadow: var(--lulu-card-shadow);
  padding: 40px 36px 32px;
  max-width: 460px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.auth-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--lulu-text-muted);
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
  align-self: flex-start;
  padding: 6px 10px 6px 4px;
  border-radius: 8px;
  transition: color 0.15s ease, background 0.15s ease;
}

.auth-back-link:hover,
.auth-back-link:focus-visible {
  color: var(--lulu-link);
  background: var(--lulu-primary-soft);
  outline: none;
}

.auth-back-icon {
  color: inherit !important;
}

.logo-link {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.auth-logo {
  height: 56px;
  width: auto;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08));
}

.auth-title {
  font-size: 24px;
  font-weight: 800;
  color: var(--lulu-text-strong);
  margin: 0 0 8px;
  text-align: center;
  letter-spacing: -0.5px;
}

.auth-subtitle {
  font-size: 14px;
  color: var(--lulu-text-muted);
  margin: 0 0 24px;
  text-align: center;
  line-height: 1.5;
}

.auth-footer {
  margin-top: 24px;
  text-align: center;
  font-size: 13px;
  color: var(--lulu-text-muted);
}

.auth-footer :deep(a) {
  color: var(--lulu-link);
  text-decoration: none;
  font-weight: 600;
}

.auth-footer :deep(a:hover) {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .auth-card {
    padding: 32px 24px 24px;
    border-radius: 16px;
  }
}
</style>
